// 
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import React from 'react';

// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const NotFound = () => {
  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <h1>404 Not Found</h1>
};

export default NotFound;